import { pollingEventStatus } from '@/common/polling';
import { upgradeSuccessPage, wiseUpgradeSuccessPage } from '@/common/service/common';
import store from '@/store/index';
import { pageConfig } from '@/common/service/page-config';
import { updatePlans } from '@/apis';
import { cloneDeep } from 'lodash';
import { omitBy } from 'lodash';
import { APM, WISE } from '@/views/checkout/payment/helper/constant';

export const UpdateTypes = {
  UPDATE_BASE: 1, // Update Zoom Meeting / BIZ Plus
  UPDATE_ADDON: 2, // Update other plans.
  UPDATE_PBX: 3,
  PRO_TO_BIZ: 4,
  MEETING_TO_BIZ_PLUS: 5, // upgrade pro/biz to biz plus
  PRO_TO_BIZ_PLUS: 5, // upgrade pro to biz plus
  BIZ_TO_BIZ_PLUS: 5, // upgrade biz to biz plus
  PRO_PLUS_TO_PRO_PLUS: 5, // upgrade pro plus to pro plus
  BIZ_TO_PRO: 6,
  BIZ_PLUS_TO_BIZ: 7, // downgrade biz plus to biz
  DOWNGRADE_TO_ZONE_BASIC_PLUS: 8,
  ZONE_BASIC_PLUS_UPGRADE_TO_MEETING: 9,
  UPDATE_TOLL_FREE: 10,
  BIZ_PLUS: 11,
  MIX_BUY_PARTNER: 12, // JUST FOR MIX BUY CASE (edit base && add addon mix case) mix buy partnership plan
  PRO_TO_PTO_PLUS: 13, // pro upgrade to pro plus
  UPDATE_PRO_PLUS: 14, // edit pro plus
  ZS_TO_ZE: 15, // zs to ze
  SWITCH: 16, // switch plan (for example: ZE SaaS -> ZE PPA / ZS SaaS -> ZS PPA)
};

export const removeEmptyValue = obj => omitBy(obj, (v) => v === "" || v === undefined || v === null);

export const getPaymentInfo = getters => {
  if(pageConfig.hasBillingZuoraId) {
    return {};
  }

  const apmInfo = getters.apmInfo;
  let { paymentResponse, paymentGateway } = getters.paymentMethodInfo;

  if (apmInfo.isApm) {
    paymentResponse = JSON.stringify({
      integrationType: APM
    })
  }

  return {
    contact: cloneDeep([removeEmptyValue(getters.billToContact), removeEmptyValue(getters.soldToContact)]),
    paymentInfo: { paymentResponse, paymentGateway },
  }
}

export const updatePlansCheckout = async (planList, actionType, couponData, extensionUpdateData, multiRatePlan = false ) => {
  const { paymentResponse } = store.getters.paymentMethodInfo;
  const preview = store.getters.isLoadingPreview;
  const { apmInfo } = store.getters;
  const params = {
    actionType,
    planList,
    paymentResponse: paymentResponse,
    couponData,
    extensionUpdateData,
    multiRatePlan,
    preview,
  };
  addParamsIfApm(params);
  const result = await updatePlans(params);
  const options = preview ? { previewKey: result?.result?.previewKey, rps: true } : { rps: true };
  const eventResult = await pollingEventStatus(options);

  if(!preview) {
    apmInfo.apmPaymentMethodName === WISE ? wiseUpgradeSuccessPage({ actionType }) : upgradeSuccessPage(null, actionType);
  }

  return { eventResult };
}

export const addParamsIfApm = (params) => {
  if (pageConfig?.apmP2PEnabled && store.getters.apmInfo?.isApm) {
    params.apmData = {
      apmName: store.getters.apmInfo?.apmPaymentMethodName
    }
    if (store.getters.apmInfo?.apmPaymentMethodName === WISE) {
      params.apmData.wisePaymentName = store.getters.apmInfo?.tileImageFileName
    }
  }
}
